"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = entropy;
/*
 * Calculate the entropy of an input string.
 */
function entropy(input) {
    if (!input || input.length === 0)
        return 0;
    let frequency = 0;
    const chars = new Set();
    const result = {
        uppercase: 0,
        lowercase: 0,
        numbers: 0,
        symbols: 0,
        norwegian: 0,
    };
    const inputCharArray = input.split("");
    inputCharArray.forEach(function (c) {
        const code = c.charCodeAt(0);
        if (code >= 97 && code <= 122) {
            result.lowercase = 1;
        }
        else if (code >= 65 && code <= 90) {
            result.uppercase = 1;
        }
        else if (code >= 48 && code <= 57) {
            result.numbers = 1;
        }
        else if ([197, 198, 216].indexOf(code) > -1) {
            result.uppercase = 1;
            result.norwegian = 1;
        }
        else if ([229, 230, 248].indexOf(code) > -1) {
            result.lowercase = 1;
            result.norwegian = 1;
        }
        else {
            result.symbols = 1;
        }
        if (!chars.has(c)) {
            chars.add(c);
            frequency++;
        }
    });
    const charSpace = result.uppercase * 26 +
        result.lowercase * 26 +
        result.numbers * 10 +
        result.symbols * 38 +
        result.norwegian * 6;
    const pwSpace = inputCharArray.reduce(function (sum, character, i) {
        return sum + Math.pow(charSpace, i + 1);
    }, 0);
    return { entropy: Math.log(pwSpace), space: pwSpace, frequency: frequency };
}
//# sourceMappingURL=entropy.js.map